export default "/assets/images/home-wrecker5.8e4d43ec4131f2c0.png";